import type { Question } from '../types';

export const questions: Question[] = [
  {
    id: 1,
    title: 'The Mistake',
    mainPrompt:
      "You know how people usually come to you while doing things with their money the WRONG way, first? What's the #1 most common mistake most of them are making that bothers you the most?",
    subPrompt: "And what's the easiest, simplest way to fix that mistake?",
    fields: [
      {
        name: 'mistake',
        label: 'The #1 Mistake',
        placeholder:
          'Describe the most common financial mistake you see clients making...',
        required: true,
      },
      {
        name: 'fix',
        label: 'The Simple Fix',
        placeholder: 'What is the easiest way to fix this mistake?',
        required: true,
      },
    ],
  },
  {
    id: 2,
    title: 'The Vision',
    mainPrompt:
      "Picture your happiest client calling you three years from now just to say 'thank you!' What exactly are they thanking you for?",
    helperText:
      "(Don't say 'peace of mind' – did you save them $50k in taxes? Did you protect their principal during a crash? Be specific.)",
    fields: [
      {
        name: 'vision',
        label: 'Their Thank You',
        placeholder:
          'Be specific about the concrete outcome they are thanking you for...',
        required: true,
      },
    ],
  },
  {
    id: 3,
    title: 'The Objections',
    mainPrompt:
      "When someone decides NOT to work with you... what is the polite 'reason' they give you?",
    subPrompt:
      "What do you think the REAL reason is that they're scared to move forward?",
    helperText:
      "(e.g., They say 'I need to think about it,' but really they're scared that 'annuities are a scam,' or 'they will lose access to their cash')",
    fields: [
      {
        name: 'objections',
        label: 'Top 3 Objections',
        placeholder: '',
        required: true,
        isArray: true,
        arrayLength: 3,
        subFields: [
          {
            name: 'politeReason',
            label: 'Polite Reason',
            placeholder: 'What they say...',
          },
          {
            name: 'realReason',
            label: 'Real Reason',
            placeholder: 'What they really fear...',
          },
        ],
      },
    ],
  },
  {
    id: 4,
    title: 'The Origin Story',
    mainPrompt:
      'Why do you recommend that solution, instead of the regular standard stuff everyone else recommends?',
    subPrompt:
      "Was there a specific moment, a client disaster, or a market event that made you realize the 'standard' advice was completely broken?",
    fields: [
      {
        name: 'solution',
        label: 'Why Your Solution',
        placeholder: 'Explain why you recommend your approach over the standard advice...',
        required: true,
      },
      {
        name: 'originStory',
        label: 'The Defining Moment',
        placeholder:
          'Describe the moment or event that shaped your approach...',
        required: true,
      },
    ],
  },
  {
    id: 5,
    title: 'The Goodie Bag',
    mainPrompt:
      'If you wanted to really impress a prospect by giving them 3 really helpful tools or resources for free (things you usually only give paying clients), what would you give them?',
    helperText:
      '(e.g., could be a checklist, a calculator, a specific book, a worksheet, or a chapter of a book)',
    fields: [
      {
        name: 'resources',
        label: '3 Free Resources',
        placeholder: '',
        required: true,
        isArray: true,
        arrayLength: 3,
      },
    ],
  },
  {
    id: 6,
    title: 'The Scarcity',
    mainPrompt:
      "Imagine you're running a special offer until Monday night. If a prospect calls you on Tuesday morning, begging to get in on the deal, why do you have to tell them 'No,' or 'Sorry, it costs more now'?",
    subPrompt: 'What did they miss out on by waiting?',
    fields: [
      {
        name: 'scarcity',
        label: 'I can only take on so many clients because...',
        placeholder:
          'I build every plan by hand — I don\'t hand clients off to junior advisors or automated systems',
        hintText:
          'What makes your time or service limited? Think about what you do personally that can\'t be scaled.',
        required: true,
      },
      {
        name: 'missedOpportunity',
        label: 'By waiting, they missed out on...',
        placeholder:
          'Having me personally review their portfolio before the next market shift',
        hintText:
          'What\'s the specific thing they\'ll never get back?',
        required: true,
      },
    ],
  },
];

export const TOTAL_QUESTIONS = questions.length;
